import { toast } from '@/common/util'
import baseApi from './base.api'
import type { DenyType } from '@/stores'
import type { ExternalCertificateType } from '@/types/types'

const api = {
  ...baseApi,
  resource: 'CertificadoExterno',
  async sendReplyRequest(objData: DenyType, approved: boolean) {
    try {
      return await api.put(`AprovarCertificadoExterno/${approved}`, {
        id: objData.id,
        tipoJustificativa: objData.justification,
        descricaoJustificativa: objData.reason
      })
    } catch (error) {
      const { notifications }: { notifications: string[] } = error.response?.data || {}
      toast.error({ message: notifications[0] || 'Erro ao tentar responder solicitação certicado externo!' })
    }
  },
  async getAdminList(): Promise<{ data: ExternalCertificateType[]; success: boolean }> {
    try {
      return await api.get('admin')
    } catch (error) {
      const { notifications }: { notifications: string[] } = error.response?.data || {}
      toast.error({ message: notifications[0] || 'Erro ao tentar listar certificados externos !' })
    }
  },
  async getByUserList(userId?: string): Promise<{ data: ExternalCertificateType[]; success: boolean }> {
    try {
      return await api.get('', {
        usuarioId: userId
      })
    } catch (error) {
      const { notifications }: { notifications: string[] } = error.response?.data || {}
      toast.error({ message: notifications[0] || 'Erro ao tentar listar certificados externos!' })
    }
  }
}

export default api
